import React, { useState, useEffect } from "react";
import api from "../../Axios/api";
import { useUserContext } from "../../context/UserContext";
import { Bar, defaults } from "react-chartjs-2";

const TopSellingProducts = () => {
  const { store } = useUserContext();
  const token = store.data.token;
  const [result, setResult] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [dateData, setDateData] = useState([]);

  const getStats = async () => {
    await api
      .get("/superAdmin/system/analytics", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        let result = res.data.data.salesListByDate;
        // setSalesListByDate([...salesListByDate, result]);
        // console.log("Sales List By Date is ", salesListByDate);
        setResult(result);
        console.log("Result is  Date is ", result);
        let orderNum = result.map((el, index) => el.orders);
        setOrderData(orderNum);

        let orderDate = result.map((el, index) => el.date.split("T")[0]);
        setDateData(orderDate);
      })
      .catch((error) => console.log(error));
  };
  const data = {
    labels: dateData,
    datasets: [
      {
        label: "Orders",
        data: orderData,
        backgroundColor: `rgba(9,0,113,.7)`,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
    backgroundColor: "#262626",
    animation: {
      duration: 3000,
      onProgress: function (animation) {
        defaults.animation = false;
      },
    },
  };

  useEffect(() => {
    getStats();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="header">
        <h2 className="title">All Sales</h2>
      </div>
      <Bar width={100} height={70} data={data} options={options} />
    </>
  );
};

export default TopSellingProducts;
